/* eslint-disable import/no-named-default */
import state from './state'
import getters from './getters'
import mutations from './mutations'
import { default as actions, INIT } from './actions'

export default {
    state,
    mutations,
    getters,
    actions,
    plugins: [
        // Call our main store `INIT` action to load global required data.
        // Note: This does NOT call `INIT` on the modules.
        (store) => store.dispatch(INIT)
    ]
}
